import { Space, Spin } from "antd";
export const PageContainer = ({ children, loading = false }) => {
  return (
    <Space direction="vertical" style={{ width: "100%" }} size={0}>
      {loading ? <Spin /> : children}
    </Space>
  );
};
